(function (angular) {
	'use strict';

	angular
		.module('twoFactorAuthModule')
		.controller('TwoFactorTotp', [
			'TwoFactorAuthFactory',
			'HTTP_STATUS',
			'urlFactory',
			TwoFactorTotpFunction
		]);

	function TwoFactorTotpFunction(
		TwoFactorAuthFactory,
		HTTP_STATUS,
		urlFactory
	) {
		var twoFactorTotp = this;

		twoFactorTotp.verify = function(form) {
			TwoFactorAuthFactory.verifyEnrollmentCode('totp', form)
				.catch(function() {
					twoFactorTotp.authCode = "";
					twoFactorTotp.verificationSuccess = false;
				});
		};

		twoFactorTotp.$onInit = function() {
			TwoFactorAuthFactory.requestQrCode().then(function(image) {
				twoFactorTotp.qrCode = image;
			}).catch(function(response) {
				if (response.status === HTTP_STATUS.CONFLICT) {
					urlFactory.redirect('/account/security/two-factor-authentication/already-enabled-failure');
				}
			});
		};
	}
})(window.angular);